import React, { Component } from "react"
import "./Index.scss"
import DataHeader from "./containers/DataHeader"
import HistoryTable from "./containers/HistoryTable"
import DataTable from "./containers/DataTable"
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer, Provider } from "mobx-react"
import pgdDataManageDetail from "app/stores/pgd/dataManageDetail"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.pgdDataManageDetail = new pgdDataManageDetail()
    this.pgdDataManageDetail.setFamilyId(props.match.params.id)
  }

  componentWillUnmount() {
    this.pgdDataManageDetail.clearState()
  }

  render() {
    return (
      <Provider pgdDataManageDetail={this.pgdDataManageDetail}>
        <div className="datamanage-detail-page pgd">
          <h2 className="page-title">
            <img alt="" src={dataIcon} />
            数据管理 > 数据详情
          </h2>
          <div className="clearfix wrapper-box-first">
            <DataHeader />
          </div>
          <div>
            <DataTable />
            <HistoryTable />
          </div>
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/data_manage_detail/index.js